<template>
  <x-mdl ref="mdl" :label="label">
      <el-form-item :prop="prop" :rules="rules" >
        <select ref="select" class="mdl-textfield__input" >
            <option value></option>
        </select>
      </el-form-item>
        <span class="typeahead-loader">
            <img src="assets/components/medcare/img/loading.gif" alt="loader">
        </span> 
  </x-mdl>
</template>

<script>
import mdl from '~/mixins/mdl'
import {fetchList} from '~/api/resource'
import { mapGetters } from 'vuex'

export default {
  name: "XSelect",
  props:{
      create : [Boolean],
      multiple : [Boolean, Number],
      valueField : {
          default : 'id'
      },
      tag :String,
       labelField : { 
           default :'title_en' 
        },
      options : {
          type : Array,
          default: () => []
      }
  },
  mixins : [mdl],
  computed:{
      ...mapGetters({
          tags : 'tags/get'
      }),
      select(){
          return this.$refs['select'];
      },
      items : {
          get(){
              return _.split(this.$data._value, ',')
          },
          set(value){
              this.$data._value = _.isArray(value) ? _.join(value, ',') : value
              this.$emit('input', this.$data._value)
          }
      }
  },
  watch:{
      value(v){
            this.refresh()
      }
  },
  methods:{
      refresh(){
         this.select.selectize.addOption(_.map(this.items,(item)=>{return {'value':item}}));
         this.select.selectize.setValue(this.items, true)
         this.updateMDL()
        //  setTimeout(() => this.updateMDL(), 100)
      },
      updateMDL(){
          this.$refs['mdl'] && this.$refs['mdl'].update();
      },
      async init(){
        $(this.select).selectize({
            plugins: ['my_plugin'],
            maxItems: this.multiple?null:1,
            hideSelected: this.create,
            createOnBlur: this.create,
            create: true,
            valueField: this.valueField,
            labelField: 'value',
            searchField: 'value',
            options: this.options,
            items: this.items,
            onFocus: () => this.updateMDL(),
            onBlur: () => this.updateMDL() ,
            onChange: (v) => this.items = v //{_log_('change', v)} //this.$emit('input', _.toNumber(v)) //
        });
        
        if(this.tag){
            if(!this.tags(this.tag)){
                this.$refs['mdl'].$el.classList.add('typeahead-is-loading')
                await this.$store.dispatch('tags/fetch', {
                    type : this.tag,
                    value : this.labelField
                });
                this.$refs['mdl'] && this.$refs['mdl'].$el.classList.remove('typeahead-is-loading')
            }
            const options = this.tags(this.tag);
            if(options){
                this.select.selectize.addOption(options);
                this.select.selectize.refreshOptions(false);
            }
        }

        this.refresh()
      }
  }
};
</script>
